import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Chip, Icons } from '@curves/ui-base';


const RadioChip = React.forwardRef((props, ref) => {
    const { defaultChecked, label, disabled, onChange } = props;
    const [isChecked, setIsChecked] = useState(defaultChecked);
    const [isClicked, setClicked] = useState(false);
    const ChipIcon = isChecked ? Icons.SuccessOutlined : Icons.RadioButtonUnchecked;
    const chipColor = disabled ? 'gray' : isChecked ? 'primary' : '';
    const iconColor = disabled ? 'gray' : 'primary';
    const handleClick = () => {
        if (!disabled) {
            setIsChecked(!isChecked);
            setClicked(true);
        }
    };
    useEffect(() => {
            if (isClicked) {
                setClicked(!isClicked);
                onChange && onChange();
            }
        },
        // eslint-disable-next-line
        [isClicked]
    );
    useImperativeHandle(ref, () => ({
        checked: () => !disabled && isChecked,
        setChecked: (nextChecked) => setIsChecked(nextChecked),
    }));
    return <Chip ref={ref} label={label} color={chipColor}
                 icon={<ChipIcon color={iconColor} />}
                 onClick={handleClick}
                 disabled={disabled}
    />
});
export default RadioChip;